/* bf26y-qa.js (12 Oct 2026): phone gallery fit. Rollback: delete the bf26y-qa script line in snippets/bf26z-sitewide.liquid. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');
  function shown(el) { return !!el && getComputedStyle(el).display !== 'none'; }
  function fit(mg) {
    var ul = mg.querySelector('ul.product__media-list');
    if (!ul) return;
    var slides = [].slice.call(ul.children).filter(function (s) { return s.classList.contains('product__media-item'); });
    var dots = [].slice.call(mg.querySelectorAll('.slider-counter__link--dots'));
    if (dots.length && dots.length === slides.length) {
      dots.forEach(function (d, i) {
        var want = shown(slides[i]) ? '' : 'none';
        if (d.style.display !== want) d.style.display = want;
      });
    }
    if (!mq.matches) { if (ul.style.height) ul.style.height = ''; return; }
    var box = ul.getBoundingClientRect(), mid = box.left + box.width / 2, best = null, bd = 1e9;
    slides.forEach(function (s) {
      if (!shown(s)) return;
      var r = s.getBoundingClientRect();
      if (!r.width) return;
      var d = Math.abs(r.left + r.width / 2 - mid);
      if (d < bd) { bd = d; best = s; }
    });
    if (!best) return;
    var h = best.offsetHeight;
    if (h > 0) { var v = h + 'px'; if (ul.style.height !== v) ul.style.height = v; }
  }
  function init(mg) {
    if (mg.__bfq) return; mg.__bfq = 1;
    var ul = mg.querySelector('ul.product__media-list');
    if (!ul) return;
    var raf = 0;
    function later() {
      if (raf) return;
      var run = function () { if (!raf) return; cancelAnimationFrame(raf); raf = 0; fit(mg); };
      raf = requestAnimationFrame(run);
      setTimeout(run, 150); /* r55 FX3: also when frames are paused (background tab), so the dot count never stays stale */
    }
    ul.addEventListener('scroll', later, { passive: true });
    ul.addEventListener('load', later, true);
    window.addEventListener('resize', later);
    /* r55 FX3 (Q2-06/Q2-14): watch the whole gallery, not one list: after a colour change the theme can swap the slide list or the dots,
       and a watcher left on the old list never re-counted the dots (Scrunch showed 6 photos and 1 dot). fit() reads the live list each time. */
    if (window.MutationObserver) new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) { var t = list[i].target; if (t && t.classList && t.classList.contains('slider-counter__link')) continue; later(); return; }
    }).observe(mg, { attributes: true, attributeFilter: ['class', 'style', 'hidden'], subtree: true, childList: true });
    mg.addEventListener('scroll', later, true);
    if (window.ResizeObserver) { var ro = new ResizeObserver(later); [].forEach.call(ul.children, function (s) { ro.observe(s); }); }
    fit(mg); setTimeout(later, 600); setTimeout(later, 1800);
  }
  function run() { [].forEach.call(document.querySelectorAll('media-gallery'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
})();
/* 21 Oct 2026 (speed, flicker): no longer loads assets/bf26y-price.js. Every RKKN Set price it wrote is rendered by the server (snippets/price.liquid + rk-set-price, sections/announcement-bar.liquid, #rk-set-data); it also ran a whole-page observer on every page. */
